// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore";

const name = "sceneFragmentDeclaration";
const shader = `uniform mat4 viewProjection;
#ifdef MULTIVIEW
uniform mat4 viewProjectionR;
#endif
uniform mat4 view;
uniform mat4 projection;
uniform vec4 vEyePosition;`;
// Sideeffect
if (!ShaderStore.IncludesShadersStore[name]) {
    ShaderStore.IncludesShadersStore[name] = shader;
}

/** @internal */
export const sceneFragmentDeclaration = { name, shader };
